(function () {
  if (window.__nativeScentCarouselInitialized) {
    return;
  }
  window.__nativeScentCarouselInitialized = true;
  var SECTION_SELECTOR = '[data-section-type="scent-carousel"]';
  var INITIALIZED_ATTR = 'scentCarouselInitialized';
  var cleanupMap = new WeakMap();

  var findSections = function (root) {
    if (!root || !root.querySelectorAll) {
      return [];
    }
    return Array.prototype.slice.call(root.querySelectorAll(SECTION_SELECTOR));
  };

  var clamp = function (value, min, maxValue) {
    return Math.min(Math.max(value, min), maxValue);
  };

  var initializeSection = function (section) {
    if (!section || section.dataset[INITIALIZED_ATTR] === 'true') {
      return;
    }
    var viewport = section.querySelector('[data-carousel-track]');
    if (!viewport) {
      return;
    }

    section.dataset[INITIALIZED_ATTR] = 'true';

    var prevButton = section.querySelector('[data-carousel-prev]');
    var nextButton = section.querySelector('[data-carousel-next]');
    var progressBar = section.querySelector('[data-carousel-progress]');
    var progressTrack = progressBar ? progressBar.parentElement : null;
    var addToCartButtons = section.querySelectorAll('[data-carousel-atc]');
    var resizeObserver = null;
    var windowResizeHandler = null;
    var progressIndicatorWidth = 0;
    var maxScroll = 0;

    var listeners = [];
    var addListener = function (target, eventName, handler, options) {
      if (!target) {
        return;
      }
      target.addEventListener(eventName, handler, options || false);
      listeners.push(function () {
        target.removeEventListener(eventName, handler, options || false);
      });
    };

    var getGap = function () {
      var styles = window.getComputedStyle(viewport);
      var gapValue = styles.columnGap || styles.gap || '0';
      var parsed = parseFloat(gapValue);
      return Number.isNaN(parsed) ? 0 : parsed;
    };

    var getItemSpan = function () {
      var firstItem = viewport.querySelector('.scent-carousel__item');
      if (!firstItem) {
        return 0;
      }
      return firstItem.getBoundingClientRect().width + getGap();
    };

    var updateProgressPosition = function () {
      if (!progressBar || !progressTrack) {
        return;
      }
      var trackWidth = progressTrack.offsetWidth;
      if (!trackWidth) {
        progressBar.style.transform = 'translateX(0)';
        return;
      }
      var ratio = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      var maxOffset = Math.max(trackWidth - progressIndicatorWidth, 0);
      var offset = maxOffset * clamp(ratio, 0, 1);
      progressBar.style.transform = 'translateX(' + offset.toFixed(2) + 'px)';
    };

    var updateProgressMetrics = function () {
      if (!progressBar || !progressTrack) {
        return;
      }
      var trackWidth = progressTrack.offsetWidth;
      if (!trackWidth) {
        progressIndicatorWidth = 0;
        progressBar.style.width = '0px';
        progressBar.style.transform = 'translateX(0)';
        return;
      }
      if (maxScroll <= 0) {
        progressIndicatorWidth = trackWidth;
      } else {
        var desiredWidth = 132;
        progressIndicatorWidth = Math.min(trackWidth, desiredWidth);
      }
      progressBar.style.width = progressIndicatorWidth.toFixed(2) + 'px';
      updateProgressPosition();
    };

    var updateUI = function () {
      updateProgressPosition();
      if (prevButton) {
        prevButton.disabled = viewport.scrollLeft <= 1;
      }
      if (nextButton) {
        nextButton.disabled = maxScroll - viewport.scrollLeft <= 1;
      }
    };

    var updateMetrics = function () {
      maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
      updateProgressMetrics();
      updateUI();
    };

    var scrollByStep = function (direction) {
      var distance = getItemSpan();
      if (!distance) {
        return;
      }
      viewport.scrollBy({
        left: distance * direction,
        behavior: 'smooth'
      });
    };

    var addItemToCart = function (variantId, button) {
      if (!variantId) {
        return;
      }
      var root = (window.Shopify && window.Shopify.routes_root)
        ? window.Shopify.routes_root
        : (window.theme && window.theme.routes && window.theme.routes.root)
          ? window.theme.routes.root
          : '/';
      var addPath = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.add)
        ? window.theme.routes.cart.add
        : '/cart/add';
      var basePath = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.base)
        ? window.theme.routes.cart.base
        : '/cart';
      var cleanedRoot = (!root || root === '/') ? '' : root.replace(/\/$/, '');

      var buildEndpoint = function (path) {
        if (!path) {
          return '';
        }
        var normalized = path.startsWith('/') ? path : '/' + path;
        var endpoint = cleanedRoot + normalized;
        if (!endpoint.endsWith('.js')) {
          endpoint += '.js';
        }
        return endpoint;
      };

      var addEndpoint = buildEndpoint(addPath);
      var cartEndpoint = buildEndpoint(basePath);

      var emit = function (name, detail) {
        document.dispatchEvent(new CustomEvent(name, detail ? { detail: detail } : undefined));
      };

      var updateOrder = function (id) {
        try {
          var storageKey = 'fluco_cart_order';
          var existing = localStorage.getItem(storageKey);
          var parsed = existing ? JSON.parse(existing) : [];
          if (!Array.isArray(parsed)) {
            parsed = [];
          }
          var updated = [id].concat(parsed.filter(function (storedId) {
            return storedId !== id;
          }));
          localStorage.setItem(storageKey, JSON.stringify(updated));
        } catch (error) {
          // no-op
        }
      };

      var sortCart = function (cart) {
        try {
          var storageKey = 'fluco_cart_order';
          var existing = localStorage.getItem(storageKey);
          var parsed = existing ? JSON.parse(existing) : [];
          if (Array.isArray(parsed) && parsed.length) {
            cart.sorted = cart.items.slice().sort(function (a, b) {
              return parsed.indexOf(a.variant_id) - parsed.indexOf(b.variant_id);
            });
            return cart;
          }
        } catch (error) {
          // no-op
        }
        cart.sorted = cart.items;
        return cart;
      };

      var fetchCart = function () {
        return fetch(cartEndpoint, {
          method: 'GET',
          credentials: 'include'
        }).then(function (response) {
          return response.json();
        }).then(function (cart) {
          return sortCart(cart);
        });
      };

      emit('cart:updating');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      fetch(addEndpoint, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data && (data.status === 422 || data.status === '422')) {
          var errorMessage = data.description || 'Unable to add to cart';
          emit('cart:error', {
            message: errorMessage
          });
          throw new Error(errorMessage);
        }
        updateOrder(variantId);
        var lineItem = data && data.items ? data.items[0] : data;
        if (lineItem) {
          emit('cart:item-added', {
            product: lineItem
          });
        }
        return fetchCart().then(function (cart) {
          if (window.theme) {
            window.theme.cartData = cart;
          }
          window.emit("quick-cart:updated", cart);
          window.emit("quick-cart:open", cart);
          window.emit("cart:updated", cart);
          document.dispatchEvent(new CustomEvent('quick-cart:updated'));
          return cart;
        });
      }).catch(function (error) {
        if (error && error.message) {
          emit('cart:error', {
            message: error.message
          });
        }
      }).finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    };

    var passiveScrollOptions = { passive: true };
    var handleScroll = function () {
      updateUI();
    };
    addListener(viewport, 'scroll', handleScroll, passiveScrollOptions);

    var handlePrevClick = function () {
      scrollByStep(-1);
    };
    var handleNextClick = function () {
      scrollByStep(1);
    };
    addListener(prevButton, 'click', handlePrevClick);
    addListener(nextButton, 'click', handleNextClick);

    addToCartButtons.forEach(function (button) {
      addListener(button, 'click', function () {
        var variantId = button.getAttribute('data-variant-id');
        addItemToCart(variantId, button);
      });
    });

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        updateMetrics();
      });
      resizeObserver.observe(viewport);
    } else {
      windowResizeHandler = function () {
        updateMetrics();
      };
      window.addEventListener('resize', windowResizeHandler);
    }

    updateMetrics();

    var cleanup = function () {
      listeners.forEach(function (unsubscribe) {
        unsubscribe();
      });
      listeners = [];
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      if (windowResizeHandler) {
        window.removeEventListener('resize', windowResizeHandler);
        windowResizeHandler = null;
      }
      delete section.dataset[INITIALIZED_ATTR];
      cleanupMap.delete(section);
    };

    cleanupMap.set(section, cleanup);
  };

  var destroySection = function (section) {
    if (!section) {
      return;
    }
    var cleanup = cleanupMap.get(section);
    if (cleanup) {
      cleanup();
    }
  };

  var initAll = function (root) {
    findSections(root || document).forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) {
      return;
    }
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = null;
    if (event && event.detail && event.detail.sectionId) {
      var wrapper = document.getElementById('shopify-section-' + event.detail.sectionId);
      if (wrapper) {
        section = wrapper.querySelector(SECTION_SELECTOR);
      }
    }
    if (!section && event && event.target) {
      if (event.target.matches && event.target.matches(SECTION_SELECTOR)) {
        section = event.target;
      } else if (event.target.querySelector) {
        section = event.target.querySelector(SECTION_SELECTOR);
      }
    }
    destroySection(section);
  });
})();
